var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
import { Table } from 'semantic-ui-react';
import Divider from '../Divider/Divider';
const TableDivider = (_a) => {
    var { content, colspan, className } = _a, rest = __rest(_a, ["content", "colspan", "className"]);
    return (React.createElement(Table.Cell, Object.assign({ colspan: colspan, className: cn(className, 'divider') }, rest),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "content" }, content),
            React.createElement(Divider, { dashed: true }))));
};
export default TableDivider;
//# sourceMappingURL=TableDivider.js.map